/**
 * Section header component with consistent typography and spacing.
 * Provides standardized section titles across the application.
 * Supports children content for additional section elements.
 * Used in CallSessionDetails and CallSessionMetrics for section organization.
 */


import React from 'react';

const SectionHeader = ({ 
  title, 
  className = '',
  children 
}) => {
  return (
    <div className={`mb-4 ${className}`}>
      <h3 className="text-lg font-semibold text-gray-900 mb-4">
        {title}
      </h3>
      {children}
    </div>
  );
};

export default SectionHeader;